/**
 * @voltxampere/ui — ZR285 low-power voltage reference variant (Sprint 42-3)
 *
 * Reference: ZMID ZR285. Low-power 2.85 V shunt reference for
 * battery-powered designs (3.0 V Li-coin-cell rails after diode
 * drop). TO-92 package, lower I_Q than LM4040.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const referenceZr285 = {
    id: "zr285",
    nameTr: "ZR285 (Düşük Güç Referans 2.85V, TO-92)",
    nameEn: "ZR285 (Low-Power Reference 2.85V, TO-92)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "ZR285",
    schemaType: "voltage-source",
    defaultParams: { voltage: 2.85 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=reference-zr285.js.map